// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__34vLO","bigColWidth":"Table_bigColWidth__QhhYB","biggerColWidth":"Table_biggerColWidth__W9t5d","row":"Table_row__1iymH","col":"Table_col__2oE9x"};